import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LocalStorageService } from './services/local-storage.service';
import { UserContextService } from './services/user-context.service';
import { CredentialsManager } from './services/credentils.manager';



@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        LocalStorageService,
        UserContextService,
        CredentialsManager,
    ] })
export class CoreModule { }
